'use client';
import React, { FC } from 'react';
import Slider, { Settings } from 'react-slick';
import { TypeSideBySideCarouselFields } from '@/core/generated-types';
import { MediaAndTextSideBySide } from '../MediaAndTextSideBySide';
import { Arrow } from '../Carousel/Arrows';
import { HeaderText } from '@/components/ui';
import { HeaderSize } from '@/components/ui/HeaderText';

const SideBySideCarousel: FC<TypeSideBySideCarouselFields> = ({
  slides = [],
  title,
  maxWidth,
}) => {
  const settings: Settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <Arrow direction={'right'} />,
    prevArrow: <Arrow direction={'left'} />,
  };

  return (
    <div
      className="mx-auto mb-16 mt-10 md:my-12 md:mb-10 md:px-16 md:pb-12"
      style={{ maxWidth }}
    >
      {title && (
        <HeaderText
          classes="text-center mb-6 md:mb-8"
          size={HeaderSize.H2}
          text={title}
        />
      )}
      <Slider {...settings} className="slider-variant-side-by-side-carousel">
        {slides.map((slide) => {
          return (
            <div
              data-testid="media-and-text-slide"
              key={slide.sys.id}
              className={`media-and-text-slide overflow-hidden rounded md:bg-none bg-${slide.fields?.backgroundColor?.fields?.color} text-center md:text-left`}
            >
              <MediaAndTextSideBySide {...slide.fields} />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default React.memo(SideBySideCarousel);
